import { ajv } from '@cibo/core/src/utils/ajv'
import type { JSONSchema7WithErrors } from '@cibo/core/src/types/JSONSchema7WithErrors'
import type { WarningEntry } from 'dynamic-uniforms'

export type { WarningEntry }

export function createWarningsValidator(schema: JSONSchema7WithErrors) {
  const validate = ajv.compile(schema)
  return async (model: any) => {
    const errors: Record<string, WarningEntry> = {}
    const result = validate(model)
    
    await result
    
    if (validate.errors) {
      for (const err of validate.errors) {
        const path = err.instancePath
          .slice(1) // remove leading "/"
          .replace(/\//g, '.') // convert "/" separators to "."
        if (path) {
          errors[path] = {
            message: err.message || 'Warning',
            keyword: err.keyword,
          }
        }
      }
    }
    return errors
  }
}
